<template>
    <div>
        <kgr-offering-stat-overview
            :offering="offering"
            :appointments="appointmentList"
            :booking-from="bookingFrom"
            :booking-to="bookingTo"
            :is-training="true"
        />
        <kgr-accordion>
            <div
                v-for="(appointment, index) in appointmentList"
                :key="appointment.key"
                @click="toggleItem(appointment, index)"
            >
                <kgr-training-appointment-accordion-item
                    :appointment-prop="appointment"
                    :instructors="instructors"
                    :replies="replies"
                    :offering="offering"
                    :club-id="clubId"
                    :user-id="userId"
                    :table-columns="tableColumns"
                    :index="index"
                    :error="error"
                    :pending="pending"
                    :active="index === activeIndex"
                    :search-open-index="searchOpenIndex"
                    @updateAppointment="updateAppointment(index, $event)"
                    @updateReplies="getReplies($event)"
                    @openSearch="searchOpenIndex = $event"
                />
                <div class="kgr-row"></div>
            </div>
        </kgr-accordion>
    </div>
</template>

<script>
import Accordion from '../../common/accordion/Accordion.vue';
import Error from '../../../js/model/Error.js';
import Offering from '../../../js/dto/offering/Offering.js';
import OfferingStatsOverview from './OfferingStatsOverview.vue';
import TableColumnRepository from '../../../js/repository/club/offering/TableColumnRepository.js';
import TrainingAppointmentAccordionItem from './TrainingAppointmentAccordionItem.vue';
import TrainingReplyRepository from '../../../js/repository/TrainingReplyRepository.js';
import moment from 'moment';

export default {
    name: 'KgrTrainingAppointmentAccordion',
    components: {
        'kgr-accordion': Accordion,
        'kgr-offering-stat-overview': OfferingStatsOverview,
        'kgr-training-appointment-accordion-item': TrainingAppointmentAccordionItem,
    },
    props: {
        appointments: {
            type: Array,
            required: true,
        },
        instructors: {
            type: Array,
            required: true,
        },
        offering: {
            type: Offering,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        bookingFrom: {
            type: String,
            required: true,
        },
        bookingTo: {
            type: String,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            activeIndex: null,
            pending: false,
            appointmentList: this.appointments,
            replies: [],
            tableColumns: [],
            searchOpenIndex: null,
        };
    },
    computed: {
    },
    created() {
        this.loadTableColumns();
    },
    methods: {
        toggleItem(appointment, index) {
            if (this.activeIndex !== index) {
                this.activeIndex = index;
                this.getReplies(appointment);
            }
        },
        updateAppointment(index, appointment) {
            this.appointmentList[index] = appointment;
        },
        getReplies(appointment) {
            this.pending = true;
            TrainingReplyRepository.getReplies(appointment.appointmentSeries.id, moment(appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format())
                .then((replies) => this.replies = replies)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.pending = false);
        },
        loadTableColumns() {
            TableColumnRepository.findByClub(this.clubId, this.offering.id)
                .then((response) => this.tableColumns = response)
                .catch(() => this.$notify.error('error.loadingData'));
        },
        convertDate(date) {
            return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
        },
        downloadExcel() {
            window.location = `/api/club/offering/${this.offering.id}/appointments/${this.convertDate(this.bookingFrom)}/${this.convertDate(this.bookingTo)}/excel`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
